import Splide from '@splidejs/splide';

class SplideSlider {
   constructor() {
      this.events();
   }

   events() {
      const sliders = document.querySelectorAll('.splide');
      if (!sliders.length) return;

      sliders.forEach((slider) => {
         const splide = new Splide(slider, {
            type: 'loop',
            perPage: slider.dataset.perPage || 1,
            breakpoints: {
               1024: {
                  perPage: slider.dataset.perPageMedium || 1
               },
               640: {
                  perPage: slider.dataset.perPageSmall || 1
               }
            },
            gap: '1rem',
            arrows: true,
            pagination: slider.dataset.pagination !== 'no',
            autoplay: false,
            autoHeight: true,
            arrowPath: 'M22.1667 28.7917C21.8334 28.4583 ... 23.3551 29.2917C22.8962 29.2917 22.5001 29.125 22.1667 28.7917Z'
         }).mount();

         // Optional: Dynamic height adjustment on move
         splide.on('move', (newIndex) => {
            const nextSlide = slider.querySelector(`#splide01-slide0${newIndex + 1} > div`);
            const list = slider.querySelector('.splide__list');
            if (nextSlide && list) {
               const height = nextSlide.offsetHeight;
               list.style.height = `${height}px`;
               list.classList.add('transition'); // optional
            }
         });

         // Optional: Set initial height and class
         const firstSlide = slider.querySelector('#splide01-slide01 > div');
         const list = slider.querySelector('.splide__list');
         if (firstSlide && list) {
            list.style.height = `${firstSlide.offsetHeight}px`;
            list.classList.add('transition'); // mimic jQuery addClass
         }
      });
   }
}

export default new SplideSlider();